import { ParametersWidget } from "./parameterWidget.js";
import { PhotoshopController } from "../../../../photoshopController.js";
import * as noUiSlider from '../../../../../node_modules/nouislider';

declare global {
    interface HTMLElement {
        noUiSlider?: noUiSlider.API;
    }
}
export class SharpenParameterWidget extends ParametersWidget {

    constructor(parent: HTMLElement, controller: PhotoshopController, operation: any) {
        super(parent, controller);
        this.operation = operation;
        this.parent.innerHTML = SharpenParameterWidget.html();
        super.initEvent();
        this.updateModel();
        this.initializeSharpenRange();
    }

    static html() {
        return super.header() + '\
        <div id="sharpen" style="padding: 10px;">\
            <h4 class="center-align">Netteté</h4>\
            <div class="col s12 divider"></div>\
            <div class="col s12 no-padding row no-margin" style="margin-top: 10px;">\
                <div class="col s10 no-padding">Rayon</div>\
                <div class="col s2 no-padding">\
                    <input id="sh-radius-input" type="number" step="0.1">\
                </div>\
            </div>\
            <div class="col s12 no-padding">\
                <div id="sh-radius-range" class="col s12 row"></div>\
            </div>\
            <div class="col s12 divider"></div>\
            <div class="col s12 no-padding row no-margin" style="margin-top: 10px;">\
                <div class="col s10 no-padding">Gain</div>\
                <div class="col s2 no-padding">\
                    <input id="sh-gain-input" type="number">\
                </div>\
            </div>\
            <div class="col s12 no-padding">\
                <div id="sh-gain-range" class="col s12 row"></div>\
            </div>\
        </div>\
        '+ super.footer();
    }

    sh_radius_inputOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.radius = value;
        this.photoshopController.update();
    }

    sh_gain_inputOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.gain = value;
        this.photoshopController.update();
    }

    updateModel() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        if (this.photoshopController.PSEngine.activeOperation) {

            if (this.photoshopController.PSEngine.activeOperation.radius !== undefined) {
                const shRadiusInput = document.getElementById("sh-radius-input") as HTMLInputElement | null;
                if (shRadiusInput) {
                    shRadiusInput.valueAsNumber = this.photoshopController.PSEngine.activeOperation.radius;
                    shRadiusInput.min = this.photoshopController.PSEngine.activeOperation.minRadius;
                    shRadiusInput.max = this.photoshopController.PSEngine.activeOperation.maxRadius;
                }
            }
            if (this.photoshopController.PSEngine.activeOperation.gain != undefined) {
                const shGainInput = document.getElementById("sh-gain-input") as HTMLInputElement | null;
                if (shGainInput) {
                    shGainInput.valueAsNumber = this.photoshopController.PSEngine.activeOperation.gain;
                    shGainInput.min = this.photoshopController.PSEngine.activeOperation.minGain;
                    shGainInput.max = this.photoshopController.PSEngine.activeOperation.maxGain;
                }
            }
        }
    }

    updateIf() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        super.updateIf();
        if (this.photoshopController.PSEngine.activeOperation && this.photoshopController.PSEngine.activeOperation.program === 'sharpen') {
            const sharpenElement = document.getElementById("sharpen");
            if (sharpenElement) {
                sharpenElement.style.display = "";
            }
        } else {
            const sharpenElement = document.getElementById("sharpen");
            if (sharpenElement) {
                sharpenElement.style.display = "none";
            }
        }
    }

    initializeSharpenRange() {
        window.setTimeout(() => {
            if (!this.photoshopController.PSEngine) {
            return;
        }
            var gainRange = document.getElementById("sh-gain-range");
            if (gainRange) {
                if (gainRange.noUiSlider) {
                    gainRange.noUiSlider.destroy();
                }
                noUiSlider.create(gainRange, {
                    start: [this.photoshopController.PSEngine.activeOperation.gain],
                    step: 1,
                    range: {
                        min: this.photoshopController.PSEngine.activeOperation.minGain,
                        max: this.photoshopController.PSEngine.activeOperation.maxGain
                    }
                });
                if (gainRange.noUiSlider) {
                    gainRange.noUiSlider.on('update', function (values, handle) {
                        this.photoshopController.PSEngine.activeOperation.gain = Number(values[0]);
                        this.updateModel();
                        this.photoshopController.update();
                    }.bind(this));
                }
                const shGainInput = document.getElementById('sh-gain-input');
                if (shGainInput) {
                    shGainInput.addEventListener('change', function (event) {
                        this.sh_gain_inputOnChange((event.currentTarget as HTMLInputElement).value);
                        if (gainRange && gainRange.noUiSlider) {
                            gainRange.noUiSlider.set([(event.currentTarget as HTMLInputElement).value]);
                        }
                    }.bind(this));
                }
            }

            var radiusRange = document.getElementById("sh-radius-range");
            if (radiusRange) {
                if (radiusRange.noUiSlider) {
                    radiusRange.noUiSlider.destroy();
                }
                noUiSlider.create(radiusRange, {
                    start: [this.photoshopController.PSEngine.activeOperation.radius],
                    step: 0.1,
                    range: {
                        min: this.photoshopController.PSEngine.activeOperation.minRadius,
                        max: this.photoshopController.PSEngine.activeOperation.maxRadius
                    }
                });
                if (radiusRange.noUiSlider) {
                    radiusRange.noUiSlider.on('update', function (values, handle) {
                        var radius = Number(values[0]);
                        this.photoshopController.PSEngine.activeOperation.radius = radius;
                        this.updateModel();
                        this.photoshopController.update();
                    }.bind(this));
                }
                const shRadiusInput = document.getElementById('sh-radius-input');
                if (shRadiusInput) {
                    shRadiusInput.addEventListener('change', function (event) {
                        this.sh_radius_inputOnChange((event.currentTarget as HTMLInputElement).value);
                        if (radiusRange && radiusRange.noUiSlider) {
                            radiusRange.noUiSlider.set([(event.currentTarget as HTMLInputElement).value]);
                        }
                    }.bind(this));
                }
            }
        });
    }

    reglages_undoOnClick() {
        super.reglages_undoOnClick();
        this.updateModel();
        this.updateIf();
        this.initializeSharpenRange();
    }
}